var map = {
	"./bi.png": 3367,
	"./dj.png": 2122,
	"./er.png": 2601,
	"./et.png": 2751,
	"./ke.png": 5764,
	"./km.png": 7452,
	"./mg.png": 3948,
	"./mu.png": 542,
	"./mw.png": 380,
	"./mz.png": 57,
	"./rw.png": 9385,
	"./sc.png": 4234,
	"./so.png": 3414,
	"./ss.png": 5210,
	"./tz.png": 5034,
	"./ug.png": 7236,
	"./zm.png": 9099,
	"./zw.png": 5041
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4743;